import React from 'react';

const Title = ({ title }) => {
  return <h5 className="title">{title}</h5>;
};

export default Title;
